import Link from '@mui/material/Link';
import type { OverridableComponent } from '@mui/material/OverridableComponent';
import type { SvgIconTypeMap } from '@mui/material/SvgIcon';
import type { SxProps, Theme } from '@mui/system';

import IconTypography from 'reservations/base/components/IconTypography';

type IconLinkProps = {
  Icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & { muiName: string };
  children?: React.ReactNode;
  dataTestId?: string;
  href: string;
  iconSx?: SxProps<Theme>;
  linkSx?: SxProps<Theme>;
  renderIcon?: boolean;
  spacing?: string | number;
};

const IconLink = ({
  Icon,
  children,
  dataTestId,
  href,
  iconSx,
  linkSx,
  renderIcon = true,
  spacing = 1
}: IconLinkProps) => (
  <IconTypography
    Icon={Icon}
    iconSx={iconSx}
    renderIcon={renderIcon}
    spacing={spacing}
    typographySx={linkSx}
  >
    <Link
      data-testid={dataTestId}
      href={href}
      color="inherit"
      target="_blank"
      rel="noopener noreferrer"
      underline="none"
    >
      {children}
    </Link>
  </IconTypography>
);

export default IconLink;
